import { ChangeDetectionStrategy, Component, input, signal } from '@angular/core';
import { FormGroup, ReactiveFormsModule } from '@angular/forms';
import { IntStates } from 'src/app/course/tests/enum/braintree-countries.enum';
import { USAStates } from 'src/app/course/tests/enum/usa-states.enum';
import { LoadingSpinnerComponent } from '../../loading-spinner/loading-spinner.component';
import { GoogleAutocompleteInputComponent } from '../../google-autocomplete-input/google-autocomplete-input.component';

@Component({
  selector: 'app-billing-info-form',
  standalone: true,
  imports: [
    ReactiveFormsModule,
    LoadingSpinnerComponent,
    GoogleAutocompleteInputComponent
  ],
  templateUrl: './billing-info-form.component.html',
  styleUrl: '../form.component.scss',
  changeDetection: ChangeDetectionStrategy.OnPush
})
export class BillingInfoFormComponent {
  form = input.required<FormGroup>();
  loading = input<boolean>(false);
  error = input<string>(null);
  webPurchaseUrl = input<string>(null);

  internationalCountries = signal(
    Object.keys(IntStates).map((key) => ({
      name: key.replace(/_/g, ' '),
      initials: IntStates[key as keyof typeof IntStates]
    }))
  );
  states = signal(
    Object.keys(USAStates).map((key) => ({
      name: key.replace(/_/g, ' '),
      initials: USAStates[key as keyof typeof USAStates]
    }))
  );

  onAddressChange(event) {
    if (!event) {
      return;
    }

    if (event.city) {
      this.form().get('city').setValue(event.city);
    }
    if (event.state) {
      this.form().get('state').setValue(event.state);
    }
    if (event.postalCode) {
      this.form().get('zip').setValue(event.postalCode);
    }
  }
}
